import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/events`, {params: {...filter}})
  },


  create(event){
    return Http.post(`/events`, {event: {
      ...event,
    }})
  },

  createNegotiation(event) {
    let base = process.env.VUE_APP_API_BASE || "/"
    // console.log({base});
    return Http({ url: '/open_requests', method: 'post', baseURL: base, data: {event_negotiation: {...event}} })
    // return Http.get(`/monitors/${depot_id}?tk=${tk}`)
  },

  showCompanyNameByToken(filter) {
    let base = process.env.VUE_APP_API_BASE || "/"
    // console.log({base});
    return Http({ url: `/open_requests/${filter.company_token}`, baseURL: base, params: {...filter} })
    // return Http.get(`/monitors/${depot_id}?tk=${tk}`)
  },

  update(event){
    return Http.put(`/events/${event.id}`, {
      event: {
        ...event,
      },
    });
  },

  show(id) {
    return Http.get(`/events/${id}`);
  },

  delete(id){
    return Http.delete(`/events/${id}`)
  },

  send_data_for_contract(event_id){
    return Http.put(`/event_contracts/${event_id}`);
  },

}